import { render } from "./NotificationChannelSelector.vue?vue&type=template&id=6851d552&scoped=true"
import script from "./NotificationChannelSelector.vue?vue&type=script&lang=js"
export * from "./NotificationChannelSelector.vue?vue&type=script&lang=js"

import "./NotificationChannelSelector.vue?vue&type=style&index=0&id=6851d552&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6851d552"]])

export default __exports__